export enum ClinicianModalTab {
    BIO = 'bio',
    INSURANCE = 'insurance',
    EXPERTISE = 'expertise',
    APPROACHES = 'approaches',
}

export enum FilterKey {
    INSURANCE_PLAN = 'insurancePlan',
    SPECIALITY = 'speciality',
    MODALITY = 'modality',
}

export enum PillStyleType {
    USER_SELECTED = 'user-selected',
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    NORMAL = 'normal',
}

export enum MeetingAvailability {
    BOTH = 'Both',
    TELETHERAPY = 'Teletherapy',
    IN_PERSON = 'In-person',
    DISPLAY_BOTH = 'Online  or   In Person',
    DISPLAY_ONLINE = 'Online'
}
